module.exports = __webpack_public_path__ + "images/back-gray9eeab648f62424ef25d213c076b52f36.svg";